import type { CSSProperties } from 'react'

export function ShieldLogo({
  size = 32,
  className = '',
  style,
}: {
  size?: number
  className?: string
  style?: CSSProperties
}) {
  return (
    <img
      src="/shield-logo.png"
      // the PNG is 1024px; at the usual 22-44px the browser picks the 2 KB copy
      srcSet="/shield-logo-128.webp 128w, /shield-logo-256.webp 256w, /shield-logo.png 1024w"
      sizes={`${size}px`}
      alt="Immigrant Shield"
      width={size}
      height={size}
      className={className}
      style={{ display: 'block', flexShrink: 0, ...style }}
      draggable={false}
    />
  )
}
